import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1180. 支払タスク固定資産削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_fixed_assets/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
};

const destroyPaymentTaskFixedAsset = (props: Props): Promise<any> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_fixed_assets/${props.id}`
  );
};

export const useDestroyPaymentTaskFixedAsset = () => {
  return useMutation({
    mutationFn: destroyPaymentTaskFixedAsset,
  });
};
